var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({class:{
    disabled: _vm.disabled,
    error: _vm.error,
    primary: _vm.primary,
    secondary: _vm.secondary,
    overlaying: _vm.overlaying,
    warning: _vm.warning,
    grey: _vm.grey,
    text: _vm.text,
    'no-click': _vm.disableClick,
    float: _vm.float,
    rejected: _vm.rejected,
    success: _vm.success,
  },attrs:{"color":_vm.parseColor,"depressed":"","rounded":_vm.round,"outlined":_vm.secondary,"disabled":_vm.disabled,"min-width":_vm.minWidth,"min-height":_vm.minHeight,"block":_vm.block,"small":_vm.small,"width":_vm.currentWidth,"loading":_vm.loading,"text":_vm.text,"fixed":_vm.fixed,"x-small":_vm.xSmall,"ripple":!_vm.disableClick,"to":_vm.to,"href":_vm.href,"target":_vm.target,"type":_vm.type},on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.attrs,false),_vm.on),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }